import styled from "styled-components";

import { Button as DefaultButton, Spacing, Text, List } from "@otta/design";
import { pxToRem } from "@otta/design-tokens";
import { Link } from "@otta/search/components/Link";
import { Company } from "@otta/search/schema";

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${pxToRem(30)} 0 ${pxToRem(20)};
`;

const Button = styled(DefaultButton)`
  max-width: 400px;
`;

interface ICompanyEmployeeSurveysProps {
  company: Company.Company;
}

export function NoSurveysContainer({
  company: { name },
}: ICompanyEmployeeSurveysProps): React.ReactElement {
  return (
    <Container>
      <Spacing>
        <Text size={1} align="center">
          We don&apos;t have any employee endorsements for {name} yet
        </Text>
        <Text align="center">Do you work at {name}?</Text>
        <Link to="../write-an-endorsement" underline={false}>
          <Button type="button" level="primary">
            Submit an endorsement
          </Button>
        </Link>
        <List type="positive" size={1}>
          <li>
            Endorsements help job seekers understand what it&apos;s like to work
            at {name}
          </li>
          <li>
            Your response will be anonymous and only include the team you work
            in
          </li>
        </List>
      </Spacing>
    </Container>
  );
}
